/*
 * Top level module for Reports page
 */

//DataModel imported because we reqres it
define([
  "marionette",
  "jquery",
  "messaging/messenger",
  "modules/reportSplit/groups/groupTiles/groupTilesView",
  "modules/reportSplit/reports/reportModel",
], function (Marionette, $, Messenger, GroupTilesView, ReportModel) {
  var GroupTilesController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "reportTilesModule";
      this.region = options.region;
      this._setUpVents();
    },
    /**
     * This function fires when the report area is first shown.
     */
    show: function (group) {
      var reports = group.get("reports");
      if (!reports) return;
      //prune out any reports that ain't relevant to this KB
      var kbModel = Messenger.reqres.request("active:kb:model");
      var kbCategories = Messenger.reqres.request("kb:categories");
      kbModel.onSynced(function () {
        kbCategories.onSynced(function () {
          this.finishShowing(group, reports, kbModel, kbCategories);
        }, this);
      }, this);
    },
    finishShowing: function (group, reports, kbModel, kbCategories) {
      reports: for (var i = 0; i < reports.models.length; i++) {
        if (kbModel.get("agentAssist") === false) {
          if (reports.models[i].get("options").requiresAgentAssist === "true") {
            reports.models.splice(i, 1);
            i--; //don't skip the next report when checking
            continue; //don't also check for categories for this report or it'll blow up b/c i = -1
          }
        }
        if (kbCategories.length === 0) {
          var rptArgs = reports.models[i].get("reportArguments");
          for (var h = 0; h < rptArgs.length; h++) {
            if (rptArgs[h].paramUrl === "{catVal}") {
              reports.models.splice(i, 1);
              i--; //don't skip the next report when checking
              continue reports; //so i can't be -1 on any future checks
            }
          }
        }
        if (kbModel.get("taskManagement") === false) {
          if (reports.models[i].get("options").requiresTasks === "true") {
            reports.models.splice(i, 1);
            i--; //don't skip the next report when checking
            continue;
          }
        }
      }
      reports.sort();
      this.view = new GroupTilesView.tileGroup({ model: group, collection: reports });
      this.view.on(
        "itemview:click:report",
        function (clickedView) {
          this._selectReport(clickedView.model);
        },
        this,
      );
      this.showRegion(this.view, { loading: false });
    },
    /**
     * _setUpVents configures the messaging.
     */
    _setUpVents: function () {
      /*
       * Show the report group and load the report tiles
       */
      Messenger.vent.on(
        "show:reportGroup",
        function (group) {
          this.show(group);
          console.log("show report");
        },
        this,
      );
    },
    _selectReport: function (report) {
      Messenger.vent.trigger("switch:to:report", report);
    },
  }); //end controller

  return GroupTilesController;
});
